<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="oss-config-dialog"
  >
    <div class="form-content">
      <oss-config-form
        ref="outform"
        @submit="submit"
      ></oss-config-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import ossConfigForm from "@/components/sys/ossConfig/ossConfigForm";
import {addOrUpdateOssConfig} from "../../../api/sys/ossConfig/ossConfig";

export default {
  name: "addDialog",
  components: {
    ossConfigForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增云储存配置'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(params) {


      addOrUpdateOssConfig(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
        
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .oss-config-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
